"use client";

import { isAllowedEvent, sanitizeProperties } from "@/lib/analytics-events";

const ANON_KEY = "anon_id";

function getAnonymousId() {
  try {
    let id = window.localStorage.getItem(ANON_KEY);
    if (!id) {
      id = crypto.randomUUID();
      window.localStorage.setItem(ANON_KEY, id);
    }
    return id;
  } catch {
    return "anonymous";
  }
}

function send(payload) {
  const body = JSON.stringify(payload);
  const url = "/api/track";
  const leavingPage =
    typeof document !== "undefined" && document.visibilityState === "hidden";

  // 关页/切后台时 fetch 常被浏览器取消，sendBeacon 更适合阅读进度这类“离开前最后一击”
  if (leavingPage && typeof navigator.sendBeacon === "function") {
    const blob = new Blob([body], { type: "application/json" });
    navigator.sendBeacon(url, blob);
    return;
  }

  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}

export function track(event, properties = {}) {
  if (typeof window === "undefined") return;
  if (!isAllowedEvent(event)) {
    console.warn("[track] unknown event:", event);
    return;
  }

  const payload = {
    event,
    properties: sanitizeProperties(properties),
    anonymousId: getAnonymousId(),
    path: window.location.pathname,
    ts: Date.now(),
  };

  if (process.env.NODE_ENV !== "production") {
    console.log("[track]", payload);
  }

  send(payload);
}
